import Check from '@mui/icons-material/Check';
import Step from '@mui/material/Step';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import type { StepIconProps } from '@mui/material/StepIcon';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import { alpha, styled } from '@mui/material/styles';
import type { FC } from 'react';
import { NAVY, SURFACE_CONTAINER_LOW, YELLOW } from 'styles/tokens';

const SurveysStepConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 18,
  },
  [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
    backgroundColor: YELLOW,
  },
  [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
    backgroundColor: YELLOW,
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: SURFACE_CONTAINER_LOW,
    borderRadius: 2,
  },
}));

const StepIconRoot = styled('div')<{ ownerState: { active?: boolean; completed?: boolean } }>(({ ownerState }) => ({
  width: 36,
  height: 36,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '0.85rem',
  fontWeight: 600,
  fontFamily: 'Jost, sans-serif',
  transition: 'all 0.3s ease',
  ...(ownerState.completed && {
    backgroundColor: YELLOW,
    color: NAVY,
  }),
  ...(ownerState.active &&
    !ownerState.completed && {
      backgroundColor: YELLOW,
      color: NAVY,
      boxShadow: `0px 4px 12px ${alpha(NAVY, 0.15)}`,
    }),
  ...(!ownerState.active &&
    !ownerState.completed && {
      backgroundColor: SURFACE_CONTAINER_LOW,
      color: alpha(NAVY, 0.45),
    }),
}));

const SurveysStepIcon: FC<StepIconProps> = ({ active, completed, icon }) => (
  <StepIconRoot ownerState={{ active, completed }}>{completed ? <Check sx={{ fontSize: 18 }} /> : icon}</StepIconRoot>
);

interface SurveysStepperProps {
  activeStep: number;
  steps: string[];
}

const SurveysStepper: FC<SurveysStepperProps> = ({ activeStep, steps }) => (
  <Stepper
    activeStep={activeStep}
    alternativeLabel
    connector={<SurveysStepConnector />}
    sx={{
      mb: 3,
      '& .MuiStepLabel-label': {
        fontFamily: 'Jost, sans-serif',
        fontSize: '0.85rem',
        fontWeight: 500,
        color: alpha(NAVY, 0.55),
        mt: 1,
      },
      '& .MuiStepLabel-label.Mui-active': {
        fontWeight: 700,
        color: NAVY,
      },
      '& .MuiStepLabel-label.Mui-completed': {
        fontWeight: 600,
        color: NAVY,
      },
    }}
  >
    {steps.map((label) => (
      <Step key={label}>
        <StepLabel slots={{ stepIcon: SurveysStepIcon }}>{label}</StepLabel>
      </Step>
    ))}
  </Stepper>
);

export default SurveysStepper;
